module.exports = __webpack_public_path__ + "img/negro.f82b3aab.jpg";